const pageUrl = window.location.href;
export const ENVIRONMENT = process.env.NODE_ENV === "production" && !pageUrl.includes('qa') ? true : false;
export const RESOURCES_URL =  process.env.REACT_APP_RESOURCES_URL;
export const LOUNGE_CODE = !pageUrl.includes("localhost")
    ? pageUrl.substring(pageUrl.lastIndexOf("/") + 1)
    : process.env.REACT_APP_TEST_LOUNGE_CODE;